import {
    ENTRA_ID_ACCESS_TOKEN_EXPIRES_AT_UPDATED,
    ENTRA_ID_AUTHENTICATED,
    ENTRA_ID_AUTH_FAILED,
    ENTRA_ID_CONFIGURATION_FAILED,
    ENTRA_ID_INITIALIZATION_STARTED,
    ENTRA_ID_REAUTHENTICATION_REQUIRED,
    ENTRA_ID_REDIRECT_STARTED,
} from '../core/actions/entraIdAuthActions';

export const ENTRA_ID_SESSION_STATUS = {
    INITIALIZING: 'initializing',
    AUTHENTICATED: 'authenticated',
    REAUTHENTICATION_REQUIRED: 'reauthentication-required',
    REDIRECTING: 'redirecting',
    FAILED: 'failed',
    CONFIGURATION_FAILED: 'configuration-failed',
} as const;

export type EntraIdSessionStatus = typeof ENTRA_ID_SESSION_STATUS[keyof typeof ENTRA_ID_SESSION_STATUS];

export interface EntraIdSessionState {
    status: EntraIdSessionStatus;
    /** Current access-token expiry only; not a sign-out or session deadline. */
    accessTokenExpiresAt?: number;
}

export interface EntraIdAuthRootState {
    entraIdSession?: EntraIdSessionState;
}

interface EntraIdSessionAction {
    type: string;
    expiresAt?: number;
}

const initialState: EntraIdSessionState = {
    status: ENTRA_ID_SESSION_STATUS.INITIALIZING,
};

const entraIdSessionReducer = (
    state: EntraIdSessionState = initialState,
    action: EntraIdSessionAction,
): EntraIdSessionState => {
    switch (action.type) {
        case ENTRA_ID_INITIALIZATION_STARTED:
            return {...state, status: ENTRA_ID_SESSION_STATUS.INITIALIZING, accessTokenExpiresAt: undefined};
        case ENTRA_ID_AUTHENTICATED:
            return {...state, status: ENTRA_ID_SESSION_STATUS.AUTHENTICATED};
        case ENTRA_ID_ACCESS_TOKEN_EXPIRES_AT_UPDATED:
            return state.status === ENTRA_ID_SESSION_STATUS.AUTHENTICATED
                ? {...state, accessTokenExpiresAt: action.expiresAt}
                : state;
        case ENTRA_ID_REAUTHENTICATION_REQUIRED:
            return state.status === ENTRA_ID_SESSION_STATUS.REAUTHENTICATION_REQUIRED
                || state.status === ENTRA_ID_SESSION_STATUS.REDIRECTING
                || state.status === ENTRA_ID_SESSION_STATUS.FAILED
                || state.status === ENTRA_ID_SESSION_STATUS.CONFIGURATION_FAILED
                ? state
                : {...state, status: ENTRA_ID_SESSION_STATUS.REAUTHENTICATION_REQUIRED, accessTokenExpiresAt: undefined};
        case ENTRA_ID_REDIRECT_STARTED:
            return state.status === ENTRA_ID_SESSION_STATUS.REAUTHENTICATION_REQUIRED
                ? {...state, status: ENTRA_ID_SESSION_STATUS.REDIRECTING}
                : state;
        case ENTRA_ID_AUTH_FAILED:
            return {...state, status: ENTRA_ID_SESSION_STATUS.FAILED, accessTokenExpiresAt: undefined};
        case ENTRA_ID_CONFIGURATION_FAILED:
            return {...state, status: ENTRA_ID_SESSION_STATUS.CONFIGURATION_FAILED, accessTokenExpiresAt: undefined};
        default:
            return state;
    }
};

export default entraIdSessionReducer;

